export default __webpack_public_path__ + "136b398db34f0c50264072e2b855dd3f.png";